module.exports = __webpack_public_path__ + "img/pv-image02.53a06f2e.webp";